/**
 * BAMBOOVE — KHỐI "COUNTDOWN": phan JS  (12/10/2026 · phieu 54)
 * ---------------------------------------------------------------------------
 * Doc thoi diem ket thuc tu thuoc tinh `data-bb-countdown` (khoi Liquid dat vao),
 * moi giay cap nhat 4 o: ngay / gio / phut / giay.
 *
 * HET GIO => an khoi (khong hien "00 00 00 00" vo nghia).
 * Dinh dang nhan: "YYYY-MM-DDTHH:MM" (gio DIA PHUONG cua khach) hoac ISO day du.
 * Neu chuoi khong doc duoc => an khoi (khong hien dong ho sai).
 */
(function () {
  'use strict';

  function haiSo(n) {
    return (n < 10 ? '0' : '') + n;
  }

  function chayKhoi(khoi) {
    if (khoi.getAttribute('data-bb-cd-xong')) return;

    var chuoi = khoi.getAttribute('data-bb-countdown') || '';
    var dich = new Date(chuoi);

    // Chuoi rong / sai dinh dang => an khoi
    if (!chuoi || isNaN(dich.getTime())) {
      khoi.hidden = true;
      return;
    }

    var oNgay = khoi.querySelector('[data-bb-cd="d"]');
    var oGio = khoi.querySelector('[data-bb-cd="h"]');
    var oPhut = khoi.querySelector('[data-bb-cd="m"]');
    var oGiay = khoi.querySelector('[data-bb-cd="s"]');
    if (!oNgay || !oGio || !oPhut || !oGiay) return;

    var dongHo = null;

    function ve() {
      var con = dich.getTime() - Date.now();

      if (con <= 0) {
        if (dongHo) clearInterval(dongHo);
        dongHo = null;
        khoi.hidden = true; // het gio => an
        return;
      }

      var tong = Math.floor(con / 1000);
      var ngay = Math.floor(tong / 86400);
      var gio = Math.floor((tong % 86400) / 3600);
      var phut = Math.floor((tong % 3600) / 60);
      var giay = tong % 60;

      oNgay.textContent = String(ngay);
      oGio.textContent = haiSo(gio);
      oPhut.textContent = haiSo(phut);
      oGiay.textContent = haiSo(giay);
    }

    ve();
    if (!khoi.hidden) dongHo = setInterval(ve, 1000);

    // Danh dau da chay (tranh chay 2 lan khi Trinh soan theme nap lai)
    khoi.setAttribute('data-bb-cd-xong', '1');

    // Trinh soan theme: khoi bi xoa/khoi phuc => dung dong ho cu
    document.addEventListener('shopify:section:unload', function (e) {
      if (e.target.contains(khoi) && dongHo) {
        clearInterval(dongHo);
        dongHo = null;
      }
    });
  }

  function chay(root) {
    var pham = root || document;
    if (!pham.querySelectorAll) return;
    var ds = pham.querySelectorAll('[data-bb-countdown]');
    for (var i = 0; i < ds.length; i++) chayKhoi(ds[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      chay(document);
    });
  } else {
    chay(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    chay(e.target);
  });
})();
